export const dataLayerPush = (object) => {
    console.log(object);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(object);
};

export const correctPrice = (price) => {
    price = price.toFixed(2);

    return price.toString();
};